//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "output-list",
  data(){
    return{
      wrapperHeight:0,
      refresh: true,
      allLoaded:false,
      config:{
        title:'库存填报',
        url:'api/supplier-inventory-feedback/page',
        property: "createdDate",
        inputCondition:{
          placeholder:'物料编号/名称',
          searchCondition:'key',
          rules:[{field:"material.matCode-material.matName", option: "LIKE_ANYWHERE"}]
        }
      },
      list:[]
    }
  },
  methods:{
    getList(e,met,bol){
      this.$nextTick(()=>{
        if(bol){
          this.list = this.list.concat(e);
        }else{
          this.list = e;
        }
        if(met === 'top'){
          this.$refs.loadmore.onTopLoaded();
        }
        if(met === 'bottom'){
          this.$refs.loadmore.onBottomLoaded();
        }
      })
    },
    init: function() {
      // 父控件要加上高度，否则会出现上拉不动的情况
      this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 10;
    },
    loadTop(){
      this.$refs.header.getlist(true);
    },
    loadBottom(){
      this.$refs.header.getMore();
    },
    viewDetail(item){
      if(item.id){
        this.$router.push(`/inventory-detail/${item.id}`);
      }
    }
  },
  mounted(){
    this.init();
    this.$refs.header.getlist();
  }
}



// WEBPACK FOOTER //
// ./src/page/procu-syner/inventory-list.vue